export default {
	lastWeek: 'lastWeek',
	lastMonth: 'lastMonth',
	lastQuarter: 'lastQuarter',
	lastYear: 'lastYear',
	allTime: 'allTime',
	manual: 'manual'
}